import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var RightTrimPipe = (function () {
    function RightTrimPipe() {
    }
    RightTrimPipe.prototype.transform = function (text, chars) {
        if (chars === void 0) { chars = '\\s'; }
        return isString(text)
            ? text.replace(new RegExp("[" + chars + "]+$"), '')
            : text;
    };
    return RightTrimPipe;
}());
export { RightTrimPipe };
RightTrimPipe.decorators = [
    { type: Pipe, args: [{ name: 'rtrim' },] },
];
/** @nocollapse */
RightTrimPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=rtrim.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/rtrim.js
// module id = 264
// module chunks = 4